/**
 * Controls whether or not we use server components to render the logged out brand page
 */
export const NEXTJS_RSC_LOGGED_OUT_BRAND_PAGE_231106 = 'NEXTJS_RSC_LOGGED_OUT_BRAND_PAGE_231106';
